/*
 * @Author: wangliang wangliang@wiz.top
 * @Date: 2023-010-07 10:42:41
 * @LastEditors: wangliang wangliang@wiz.top
 * @LastEditTime: 2023-08-16 10:04:19
 * @FilePath: \wiz-safety\src\modules\position-backend-management\routes.js
 */

// 建筑楼层管理
import buildFloor from './routes/buildFloor'
import implementationArea from './routes/implementationArea'

const routes = [...buildFloor, ...implementationArea]

export default [
  {
    id: 'a3062c1b-82eb-8412-1061-bb2009758049',
    name: 'position-backend-management',
    path: '/position-backend-management',
    meta: { title: '定位后台' },
    children: routes,
  },
]
